import * as Sentry from '@sentry/gatsby'

Sentry.init({
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    // Solo adjunta el documento de la operación; las variables no se envían.
    Sentry.graphqlClientIntegration({
      endpoints: [process.env.MIDDLE_END_URL].filter(Boolean),
    }),
  ],
  // El endpoint de Apollo va primero para que la traza llegue al backend en
  // cualquier ambiente, aunque su host no esté en la lista fija.
  tracePropagationTargets: [
    ...[process.env.MIDDLE_END_URL].filter(Boolean),
    'graphql.okyapp.com',
    'qa-graphql-backend.okyapp.com',
    'dev-co.okyapp.com',
    'co.okyapp.com',
    /^\//,
  ],
  enabled: process.env.SENTRY_ENABLED === 'TRUE',
  dsn: process.env.SENTRY_DSN_KEY,
  environment: process.env.SENTRY_ENVIRONMENT,
  sampleRate: parseFloat(process.env.SENTRY_SAMPLE_RATE),
  tracesSampleRate: parseFloat(process.env.SENTRY_SAMPLE_TRACE),
  replaysSessionSampleRate: parseFloat(process.env.SENTRY_REPLAYSSESSION),
  replaysOnErrorSampleRate: parseFloat(process.env.SENTRY_REPLAYSON),
  debug: process.env.SENTRY_DEBUG === 'TRUE',
  // Cada operación GraphQL es una transacción (src/utils/sentryApolloLink.js)
  // y el SDK les adjunta los breadcrumbs, que solo se leen en los errores.
  beforeSendTransaction(event) {
    delete event.breadcrumbs
    return event
  },
})
